const t = "styles-module__onOffInputContainer___u4YYL", o = "styles-module__onOffInputTitle___aanop", _ = "styles-module__onOffInputValue___Sg9a-", n = "styles-module__switchButton___NHGRe", e = "styles-module__switchButtonCircle___rU-H4", s = "styles-module__on___erMrQ", l = "styles-module__off___S6LC5", u = "styles-module__disabled___XarT6", f = "styles-module__error___6SICQ", r = {
  onOffInputContainer: t,
  onOffInputTitle: o,
  onOffInputValue: _,
  switchButton: n,
  switchButtonCircle: e,
  on: s,
  off: l,
  disabled: u,
  error: f
};
export {
  r as default,
  u as disabled,
  f as error,
  l as off,
  s as on,
  t as onOffInputContainer,
  o as onOffInputTitle,
  _ as onOffInputValue,
  n as switchButton,
  e as switchButtonCircle
};
